import * as tslib_1 from "tslib";
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiItemService } from '../api-item/api-item.service';
import { ObjectWithLinks, ModelMeta, ModelMetaService } from '../../common';
var PropertyMap = /** @class */ (function () {
    function PropertyMap() {
    }
    return PropertyMap;
}());
export { PropertyMap };
var PropertyTitleMap = /** @class */ (function () {
    function PropertyTitleMap() {
    }
    return PropertyTitleMap;
}());
export { PropertyTitleMap };
var ApiItemBasicComponent = /** @class */ (function () {
    function ApiItemBasicComponent(service, modelMetaService, snackBar) {
        this.service = service;
        this.modelMetaService = modelMetaService;
        this.snackBar = snackBar;
        /**
         * Fire when save/post completed
         */
        this.save = new EventEmitter();
        /**
         * Form used to create an item(Entity)
         */
        this.itemFormGroup = new FormGroup({});
        /**
         * ****** EXPERIMENTAL ******
         * Collected values for the Objects with same object mapping
         */
        this.propertyMap = {};
        /**
         * ****** EXPERIMENTAL ******
         * Collected titlte for the Objects with same object mapping
         */
        this.propertyTitleMap = {};
    }
    ApiItemBasicComponent.prototype.ngOnInit = function () {
        this.handleMetaModel();
    };
    ApiItemBasicComponent.prototype.handleMetaModel = function () {
        var _this = this;
        this.modelMeta.properties.forEach(function (property) {
            var formCtrl = new FormControl();
            if (property.mappedBySource) {
                var url = _this.item._links.self.href + '/' + property.mappedBySource;
                var s = _this.service.rest.findAllByProperty(url, property.mappedBySource);
                _this.propertyMap[property.name] = s;
                // Get the model for the the property to extract the title
                _this.propertyTitleMap[property.name] = _this.modelMetaService.getModel(property.reference);
            }
            if (property.required)
                formCtrl.setValidators(Validators.required);
            _this.itemFormGroup.addControl(property.name, formCtrl);
        });
    }; // handleResponse()
    /**
     * Post Request
     */
    ApiItemBasicComponent.prototype.submitForm = function () {
        var _this = this;
        if (this.itemFormGroup.valid) {
            // Append the relationship to the model
            var savingObject = this.itemFormGroup.value;
            savingObject[this.property.mappedBy] = this.item._links.self.href;
            this.service.save(savingObject, this.modelMeta).subscribe(function (response) {
                _this.snackBar.open('Saved', '', { duration: 1000 });
                _this.save.emit(response);
            }, function (error) { return _this.handleErrors(error); });
        }
    }; // save()
    ApiItemBasicComponent.prototype.handleErrors = function (httpErrorResponse) {
        var message = httpErrorResponse.message;
        if (httpErrorResponse.error) {
            message = httpErrorResponse.error.message;
        }
        if (httpErrorResponse.status == 409) {
            message = 'Duplicate entry';
        }
        this.snackBar.open(message, '', {
            duration: 3000
        });
    }; // handleErrors()
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", ModelMeta)
    ], ApiItemBasicComponent.prototype, "modelMeta", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", ObjectWithLinks)
    ], ApiItemBasicComponent.prototype, "item", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", Object)
    ], ApiItemBasicComponent.prototype, "property", void 0);
    tslib_1.__decorate([
        Output(),
        tslib_1.__metadata("design:type", EventEmitter)
    ], ApiItemBasicComponent.prototype, "save", void 0);
    ApiItemBasicComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-api-item-basic',
            template: "<form (submit)=\"submitForm()\" [formGroup]=\"itemFormGroup\" fxLayoutAlign=\"start center\" fxLayoutAlign.xs=\"center start\" fxLayout=\"row\" fxLayoutGap=\"2vw\" fxLayout.xs=\"column\"> <div *ngFor=\"let prop of modelMeta.properties\" class=\"full-width\"> <!-- Number --> <mat-form-field fxFlex *ngIf=\"prop.type == 'number'\"> <input matInput type=\"number\" [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- String --> <mat-form-field fxFlex *ngIf=\"prop.type == 'string'\"> <input matInput [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- Color --> <mat-form-field fxFlex *ngIf=\"prop.type == 'color'\"> <input type=\"color\" matInput [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- Enum --> <mat-form-field fxFlex *ngIf=\"prop.relationShipType && prop.relationShipType === 'ENUM'\"> <mat-select [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-option *ngFor=\"let enum of prop.enums\" [value]=\"enum\"> {{ enum }} </mat-option> </mat-select> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!--  Object  Remove mapped by property and assign it. --> <div *ngIf=\"prop.relationShipType && (prop.relationShipType === 'SINGLE' && property.mappedBy !== prop.name)\"> <mat-form-field fxFlex> <mat-select [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-option *ngFor=\"let item of (propertyMap[prop.name] | async)\" [value]=\"item._links.self.href\"> {{ item[(propertyTitleMap[prop.name] | async).title] }} </mat-option> </mat-select> </mat-form-field> <!-- {{item._links.self.href | json}} {{prop.mappedBySource}} --> </div> </div> <button mat-icon-button type=\"submit\"> <mat-icon> <svg id=\"save\" viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z\" /> </svg> </mat-icon> </button> </form>",
            styles: ["mat-icon { color: #999; } .full-width { width: 100%; } /*# sourceMappingURL=api-item-basic.component.css.map */ "],
            changeDetection: ChangeDetectionStrategy.OnPush
        }),
        tslib_1.__metadata("design:paramtypes", [ApiItemService,
            ModelMetaService,
            MatSnackBar])
    ], ApiItemBasicComponent);
    return ApiItemBasicComponent;
}());
export { ApiItemBasicComponent };
//# sourceMappingURL=api-item-basic.component.js.map